import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import debounce from 'lodash.debounce'
import {
  FormGroup,
  FieldStatus,
  Select,
  MenuItem,
  RadioButton,
  RadioButtonGroup
} from 'rambler-ui'
import {createDeferHandler} from '@rambler-id/react'
import withGeo from 'models/geo'
import styles from './styles.css'

class GeoField extends PureComponent {
  static propTypes = {
    inline: PropTypes.bool,
    size: PropTypes.string,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    geo: PropTypes.object,
    autoFocus: PropTypes.bool,
    autoComplete: PropTypes.bool,
    input: PropTypes.shape(),
    meta: PropTypes.shape(),
    cerberId: PropTypes.func
  }

  loadGeoSuggest = debounce(this.props.loadGeoSuggest, 200)

  UNSAFE_componentWillMount() {
    this.props.loadGeoInfo(this.props.meta.initial)
  }

  UNSAFE_componentWillReceiveProps({meta}) {
    if (meta.initial !== this.props.meta.initial) {
      this.props.loadGeoInfo(meta.initial)
    }
  }

  search = (input) => {
    const {type, geo} = this.props

    if (input && input.length > 2) {
      this.loadGeoSuggest(input, type)
    } else if (geo.suggest.length > 0) {
      this.props.cancelGeoSuggest()
    }
  }

  changeValue = (id = 0) => {
    const {input, geo, cacheGeoInfo} = this.props
    const name = geo.suggest.reduce(
      (acc, suggest) => (suggest.id === id ? suggest.name : acc),
      null
    )

    cacheGeoInfo(id, name)
    input.onChange(id)
  }

  renderValue = (id) => this.props.geo.cache[id]

  render() {
    const {
      inline,
      size,
      label,
      placeholder,
      geo,
      autoFocus,
      autoComplete = true,
      input,
      meta,
      cerberId = () => undefined
    } = this.props

    const error = meta.touched && meta.error

    return (
      <FormGroup inline={inline} label={label} fieldId={input.name}>
        {autoComplete && !!meta.initial && (
          <RadioButtonGroup
            className={styles.radio}
            value={meta.initial === input.value ? meta.initial : '0'}
          >
            <RadioButton
              value={meta.initial}
              onChange={() => input.onChange(meta.initial)}
              data-cerber-id={cerberId('region_default')}
            >
              {geo.cache[meta.initial]}
              <span className={styles.muted}>Автоматически</span>
            </RadioButton>
            <RadioButton
              value="0"
              onChange={() => input.onChange('0')}
              data-cerber-id={cerberId('region_optional::checkbox')}
            >
              Задать
            </RadioButton>
          </RadioButtonGroup>
        )}
        {(!autoComplete || meta.initial !== input.value || !meta.initial) && (
          <div className={inline ? styles.inline : styles.normal}>
            <FieldStatus type="error" message={error}>
              <Select
                {...input}
                type="text"
                className="-metrika-nokeys"
                id={input.name}
                size={size}
                placeholder={placeholder}
                status={error ? 'error' : null}
                tabIndex="0"
                autoFocus={autoFocus || !!meta.initial}
                inputValueRenderer={this.renderValue}
                onChange={this.changeValue}
                onSearch={this.search}
                onBlur={createDeferHandler(() => input.onBlur())}
                data-cerber-id={cerberId('region_optional::enter')}
              >
                {geo.suggest.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    <div className={styles.suggestItem}>
                      {item.name}
                      {item.parents && (
                        <span className={styles.muted}>{item.parents}</span>
                      )}
                    </div>
                  </MenuItem>
                ))}
              </Select>
            </FieldStatus>
          </div>
        )}
      </FormGroup>
    )
  }
}

export default withGeo(GeoField)
